import { ToolKind } from 'shared/interfaces/tools/Tool';

export enum ProductName {
  STARTER = 'Starter',
  BASIC = 'Basic',
  PROFESSIONAL = 'Professional',
  ADVANCED = 'Advanced',
  ENTERPRISE = 'Enterprise'
}

export enum RecurringInterval {
  MONTH = 'month',
  YEAR = 'year',
  WEEK = 'week',
  DAY = 'day'
}

export interface Product {
  stripeId: string;
  stripePriceId: string;
  name: ProductName;
  price: number;
  recurringInterval: RecurringInterval;
  embeddingTokenLimit: number;
  usageTokenLimit: number;
  totalFileStorageLimit: number; // in Bytes
  totalVideosTimeLimit: number; // in seconds
  totalVoiceCallSecondsLimit: number;
  totalProvidedPhoneNumbersLimit: number;
  totalPhoneNumbersLimit: number;
  smartAssistantIntegrations: boolean;
  enableGoogleDrive: boolean;
  enabledTools: ToolKind[];
  enableApiAccess: boolean;
  enableWhiteLabel: boolean;
  enableSpecialModels: boolean;
  enableConversationAnalytics: boolean;
  enableTakeover: boolean;
  enableZapierAccess: boolean;
  storeProductsCount: number;
  enableWhatsApp: boolean;
  enableFacebook: boolean;
  enableInstagram: boolean;
  enableSync: boolean;
  enableByok: boolean;
  enableDashboardShareLink: boolean;
  enableImageChatAttachment: boolean;
  enableAudioChatAttachment: boolean;
  resourcePerSmartAssistantLimit: number;
  isCustom: boolean;
  adminLimit: number;
  memberLimit: number;
  removePoweredBy: boolean;
}
